export const VISIBILITY_OPTIONS = [
    { value: 'published', label: 'Published'},
    { value: 'unpublished', label: 'Unpublished'},
    { value: 'hidden', label: 'Hidden'}
]

export const DEFAULT_EPISODE_VISIBILITY_OPTIONS = [
    { value: true, label: "Publish When Ready"},
    { value: false, label: "Don't Publish When Ready"},
]